<template>
  <v-dialog v-model="visible" persistent max-width="800px">
    <v-card class="pb-3" :loading="loading">
      <v-card-title class="primary">
        <span class="headline white--text">Clone Bundle</span>
      </v-card-title>
      <v-card-text>
        <v-container grid-list-md class="pa-1">
          <v-layout wrap>
            <v-container fluid grid-list-xl>
              <v-layout wrap align-center>
                <v-flex xs12 sm6 d-flex>
                  <v-combobox
                    v-model="selectedItem"
                    :items="bundleList"
                    label="Please Select Bundle"
                    item-text="name"
                    small-chips
                  >
                  </v-combobox>
                </v-flex>
                <v-flex xs12 sm6 d-flex>
                  <v-text-field
                    v-model="name"
                    :disabled="!selectedItem || loading"
                    label="Enter bundle name"
                  ></v-text-field>
                </v-flex>
              </v-layout>
            </v-container>
            <v-snackbar v-model="snackbar" :timeout="2000">
              Please select a bundle.
            </v-snackbar>
          </v-layout>
        </v-container>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          :loading="loading"
          class="primary"
          @click="saveClonedBundle"
          :disabled="!selectedItem || !name || loading"
          >Create</v-btn
        >
        <v-btn class="mr-3" :disabled="loading" @click="closeDialog"
          >Cancel</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import { createNamespacedHelpers } from "vuex";
const { mapActions: mapOrderActions } = createNamespacedHelpers(`orders`);
export default {
  name: "CloneBundleDialog",
  props: ["data"],
  mounted() {},
  data() {
    return {
      visible: false,
      selectedItem: null,
      name: null,
      loading: false,
      progress: "",
      search: "",
      snackbar: false,
    };
  },
  watch: {
    selectedItem(val, prev) {
      if (val) {
        if (!this.name) {
          this.name = val.bundleName;
        }
      }
    },
  },
  computed: {
    bundleList() {
      let vm = this;
      return vm.data
        .filter(
          (obj, index, self) =>
            index === self.findIndex((el) => el.bundleId === obj.bundleId)
        )
        .sort((a, b) => a.bundleId - b.bundleId)
        .map((el) => {
          return {
            // ...el,
            bundleName: el.bundleName,
            name: `${el.bundleId} - ${el.bundleName}`,
            bundleId: el.bundleId,
          };
        });
    },
  },
  methods: {
    ...mapOrderActions(["saveNewBundle", "updateBundle", "getBundles"]),
    openDialog() {
      let vm = this;
      vm.visible = true;
    },
    closeDialog() {
      let vm = this;
      vm.visible = false;
      vm.selectedItem = null;
      vm.progress = "";
      vm.loading = false;
      vm.name = "";
    },
    saveClonedBundle() {
      let vm = this;
      const { selectedItem, name } = vm;
      const { bundleId } = selectedItem;
      if (typeof selectedItem !== "object") {
        vm.snackbar = true;
        return;
      }
      let payload = this.data
        .filter((el) => el.bundleId === bundleId)
        .sort((a, b) => a.id - b.id);
      vm.loading = true;
      payload.forEach((element, idx) => {
        vm.saveNewBundle(name).then((data) => {
          let newData = { ...element };
          newData = {
            ...element,
            bundleName: name,
            id: data.id,
            bundleId: element.bundleId,
          };
          vm.updateDetails(newData, idx + 1, payload.length);
        });
      });
    },
    updateDetails(item, current, max) {
      let vm = this;
      vm.updateBundle(item).then((data) => {
        if (current === max) {
          vm.getBundles().then(data=>{
            this.$emit("selectBundle", vm.name);
            vm.closeDialog();
          });
        }
      });
    },
  },
};
</script>